import resilience1 from "@/assets/new-site/ai/resilience-card-1.jpeg.asset.json";
import resilience2 from "@/assets/new-site/ai/resilience-card-2.webp.asset.json";
import resilience3 from "@/assets/new-site/ai/resilience-card-3.jpeg.asset.json";
import resilience4 from "@/assets/new-site/ai/resilience-card-4.webp.asset.json";
import resilience5 from "@/assets/new-site/ai/resilience-card-5.jpg.asset.json";
import streetworks1 from "@/assets/new-site/ai/streetworks-card-1.jpeg.asset.json";
import streetworks2 from "@/assets/new-site/ai/streetworks-card-2.jpeg.asset.json";
import streetworks3 from "@/assets/new-site/ai/streetworks-card-3.jpeg.asset.json";
import streetworks4 from "@/assets/new-site/ai/streetworks-card-4.jpeg.asset.json";
import streetworks5 from "@/assets/new-site/ai/streetworks-card-5.jpeg.asset.json";
import construction1 from "@/assets/new-site/ai/construction-card-1.webp.asset.json";
import construction2 from "@/assets/new-site/ai/construction-card-2.webp.asset.json";
import construction3 from "@/assets/new-site/ai/construction-card-3.webp.asset.json";
import construction4 from "@/assets/new-site/ai/construction-card-4.webp.asset.json";
import construction5 from "@/assets/new-site/ai/construction-card-5.jpeg.asset.json";

// Preserve the live homepage's image order and corresponding analysis copy.
export const aiExamplesByTopic = {
  Resilience: [
    { image: resilience1.url, title: "Low Water Level", body: "Water level is below threshold with all drains clearly visible. Debris are visible." },
    { image: resilience2.url, title: "Low Water Level", body: "Water level is below threshold with all drains clearly visible. No debris are visible." },
    { image: resilience3.url, title: "High Water Level Alert", body: "Water level has exceeded threshold and is close to top of culvert..." },
    { image: resilience4.url, title: "Low Water Level", body: "Water level is below threshold with all drains clearly visible. No debris are visible." },
    { image: resilience5.url, title: "Low Water Level", body: "Water level is below threshold with all drains clearly visible. No debris are visible." },
  ],
  Streetworks: [
    { image: streetworks1.url, title: "Site Secure", body: "all cones, barriers and signs in position." },
    { image: streetworks2.url, title: "Site Secure", body: "all cones, barriers and signs in position." },
    { image: streetworks3.url, title: "Barriers down", body: "Several barriers are on the floor." },
    { image: streetworks4.url, title: "Site Secure", body: "all cones, barriers and signs in position." },
    { image: streetworks5.url, title: "Site Secure", body: "all cones, barriers and signs in position." },
  ],
  Construction: [
    { image: construction1.url, title: "Site Clear", body: "Road surface clean and unobstructed." },
    { image: construction2.url, title: "Site Clear", body: "Works area tidy with no debris on road." },
    { image: construction3.url, title: "Mud In Road", body: "Mud tracked onto the carriageway from site." },
    { image: construction4.url, title: "Site Clear", body: "Operative cleaning down the road surface." },
    { image: construction5.url, title: "Site Clear", body: "Works in progress with road kept clear." },
  ],
};